import React from 'react';
import styles from './styles';

export default ({ tablesData, setTablesData, pageContent }) => {
  const cls = styles();
  const sslDefault = tablesData?.ssl_default || {};
  const ssl = tablesData?.ssl || {};

  const handleChangeSSl = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setTablesData((prev) => {
      return {
        ...prev,
        ssl: {
          ...prev.ssl,
          [name]: value,
        },
      };
    });
  };

  return (
    <div>
      <h3 className={cls.header}>SSL NAMING</h3>
      <div className={cls.listContainer}>
        <table className={cls.list}>
          <thead>
            <tr>
              <th style={{ flex: 0.7 }}>SMART TURN</th>
              <th style={{ flex: 1 }}>SSL</th>
              <th style={{ flex: 0.7 }}>USER</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(sslDefault).map((key, index) => (
                <tr>
                  <td style={{ flex: 1 }}>{key}</td>
                  <td style={{ flex: 0.7 }}>{sslDefault[key]}</td>
                  <td style={{ flex: 0.7 }}>
                    {pageContent &&
                    (pageContent.value === 1 || pageContent.value === 2) ? (
                      <>{ssl[key] || ''}</>
                    ) : (
                      <input
                        onChange={(e) => handleChangeSSl(e)}
                        type="text"
                        defaultValue={ssl[key] || ''}
                        // value={tablesData.ssl_default[key]}
                        name={key}
                      />
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
